import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind class lists, resolving conflicts so the last wins.
 * Every design-system component that forwards `className` runs it through this,
 * so consumer overrides beat the component's defaults.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
